import { DOC_SAVING_FAILED, DOC_SAVING_SUCCESSED } from "../actions/types";
const initialState = {
	body: [],
	saved: false,
};
export default function (state = initialState, action) {
	switch (action.type) {
		case DOC_SAVING_SUCCESSED:
			return {
				...state,
				body: action.payload,
				saved: true,
			};
		case DOC_SAVING_FAILED:
			return {
				...state,
				saved: false,
			};
		default:
			return state;
	}
}
